import { render, staticRenderFns } from "./fansList.vue?vue&type=template&id=4615cebf&scoped=true"
import script from "./fansList.vue?vue&type=script&lang=js"
export * from "./fansList.vue?vue&type=script&lang=js"
import style0 from "./fansList.vue?vue&type=style&index=0&id=4615cebf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4615cebf",
  null
  
)

export default component.exports